import React, { useContext, useRef } from 'react'
import { CloseButton, DocumentContainer, DownloadButton, HeacerDoc, ModalContainer, StructureName, Structures, StructuresContainer } from './style'
import CertificatesContext from '../../../contexts/CertificatesContext'
import SimpleData from '../ViewCertificate/SimpleData'
import Signature from '../ViewCertificate/Signature'
import ViewStructuresTable from '../ViewCertificate/ViewStructuresTable'
import download from '../../../assets/download.svg'
import { useReactToPrint } from 'react-to-print'

const ViewCertificateModal:React.FC = () => {
  const { certificate } = useContext(CertificatesContext)
    const contentRef = useRef<HTMLDivElement | null>(null)
    const handlePrint = useReactToPrint({
      contentRef, 
      documentTitle:`Certificado_${certificate.customerCompany.companyName}`
    })
  
  return(
    <ModalContainer>
      <DownloadButton onClick={() => handlePrint()}>
        <img src={download} alt='download icon'/>
      </DownloadButton>
      <DocumentContainer ref={contentRef}>
        <HeacerDoc>
          {certificate.supplierCompany.id === 1 ? 
            <img draggable='false' src="https://dustre.com.br/wp-content/uploads/2022/11/logo.svg"/>
          : 
            <h1>{certificate.supplierCompany.companyName}</h1>
          }
        </HeacerDoc>
        <SimpleData certificate={certificate} />
        <StructuresContainer>
          {certificate.structures.map((item, index) => (
            <Structures key={index}>
              <StructureName>
                {item.name}
              </StructureName>
              <ViewStructuresTable structure={item} />
            </Structures>
          ))}
        </StructuresContainer>
        <Signature />
      </DocumentContainer>
    </ModalContainer>
  )
}

export default ViewCertificateModal